
const TemplateFour = () => {
    return (
      <div className="slideshow">
        <figure>
          {/* Project Details Starts */}
          <figcaption>
            <h3>HTML TEMPLATE</h3>
            <div className="row open-sans-font">
              <div className="col-12 mb-2">
                <i class="fab fa-html5"></i>
                <span className="ft-wt-600 uppercase"> 2021 IT Solutions and Services Company is a Modern & Professional which is perfectly suitable for the Technology IT Solutions & Services HTML Template that comes with 13+ valid HTML pages and 03+ home pages.</span>
              </div>
            </div>
            {/* End .row */}
          </figcaption>
          {/* Project Details Ends */}
  
          {/*  Main Project Content Starts */}
          <img src="img/projects/templates/4.jpg" alt="Portolio" />
          {/* Main Project Content Ends */}
        </figure>
      </div>
      //  End .slideshow
    );
  };
  
  export default TemplateFour;
  